import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import {
  API_BASE_URL,
  ApiClient,
  EditManualPaymentRequestDto,
  IPaymentMethodInfo,
  PaymentDetails,
  PaymentHistoryEntry,
  PaymentInfo,
  PaymentMethodInfo,
  PaymentSummary,
  RecordManualPaymentRequestDto,
} from '../sdk/sdk';

@Injectable({
  providedIn: 'root',
})
export class PaymentService {
  private readonly sdk = inject(ApiClient);
  private readonly http = inject(HttpClient);
  private readonly baseUrl = inject(API_BASE_URL, { optional: true }) ?? '';

  getPaymentSummary(opportunityId: string): Observable<PaymentSummary> {
    return this.sdk.getPaymentSummary(opportunityId);
  }

  getPaymentHistory(opportunityId: string): Observable<PaymentHistoryEntry[]> {
    return this.sdk.getPaymentHistory(opportunityId);
  }

  getPaymentDetails(opportunityId: string): Observable<PaymentDetails> {
    return this.sdk.getPaymentDetails(opportunityId);
  }

  getManualPaymentMethods(context?: 'edit'): Observable<PaymentMethodInfo[]> {
    if (context) {
      return this.http
        .get<IPaymentMethodInfo[]>(`${this.baseUrl}/api/v1/payments/methods?context=${context}`)
        .pipe(map(items => items.map(item => PaymentMethodInfo.fromJS(item))));
    }
    return this.sdk.getManualPaymentMethods(undefined);
  }

  recordManualPayment(dto: RecordManualPaymentRequestDto): Observable<PaymentInfo> {
    return this.sdk.recordManualPayment(dto);
  }

  editManualPayment(paymentId: string, dto: EditManualPaymentRequestDto): Observable<PaymentInfo> {
    return this.sdk.editManualPayment(paymentId, dto);
  }
}
